import { useMutation } from "@tanstack/react-query";
import { Button, Checkbox, DatePicker, Form, Input, message } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  addClosedPeriods,
  deleteClosedPeriod,
  updateClosedPeriods,
} from "../../../../network/settings";
import queryClient from "../../../../services/react-query/queryClient";
import { queryKeys } from "../../../../services/react-query/queryKeys";
const svg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5619 13.8035C12.5272 13.8035 12.493 13.7962 12.4614 13.782C12.4299 13.7678 12.4017 13.747 12.3788 13.721C12.3447 13.6826 11.5469 12.7645 11.5469 11.6073C11.5469 10.4501 12.3447 9.53195 12.3788 9.4932C12.4017 9.46725 12.4299 9.44647 12.4614 9.43224C12.493 9.418 12.5272 9.41064 12.5619 9.41064C12.5965 9.41064 12.6307 9.418 12.6623 9.43224C12.6939 9.44647 12.7221 9.46725 12.745 9.4932C12.7787 9.53195 13.5766 10.4501 13.5766 11.6073C13.5766 12.7645 12.7806 13.6826 12.7453 13.721C12.7223 13.747 12.6941 13.7678 12.6625 13.782C12.6308 13.7962 12.5966 13.8035 12.5619 13.8035ZM12.5619 10.0626C12.3516 10.3766 12.0353 10.957 12.0353 11.6073C12.0353 12.2576 12.3509 12.8395 12.5613 13.1523C12.7716 12.8398 13.0884 12.2579 13.0884 11.6073C13.0884 10.9566 12.7725 10.3766 12.5619 10.0626Z"
      fill="#00086D"
    />
    <path
      d="M12.5635 13.8028H12.5481C12.4969 13.7997 11.2847 13.7153 10.4653 12.8965C9.64596 12.0778 9.56158 10.8653 9.55908 10.814C9.55689 10.7794 9.56208 10.7448 9.57432 10.7123C9.58656 10.6799 9.60556 10.6504 9.63007 10.6259C9.65457 10.6013 9.68401 10.5823 9.71644 10.57C9.74887 10.5578 9.78354 10.5525 9.81815 10.5547C9.86971 10.5581 11.0841 10.6453 11.9006 11.4609C11.9326 11.4917 11.9628 11.5244 11.991 11.5587C12.011 11.5837 12.0259 11.6125 12.0349 11.6432C12.0438 11.674 12.0466 11.7063 12.0431 11.7381C12.0396 11.77 12.0299 11.8008 12.0144 11.8289C11.999 11.857 11.9782 11.8818 11.9531 11.9019C11.9281 11.9219 11.8994 11.9368 11.8686 11.9458C11.8379 11.9547 11.8056 11.9575 11.7738 11.954C11.7419 11.9505 11.711 11.9408 11.6829 11.9253C11.6548 11.9099 11.6301 11.8891 11.61 11.864C11.5928 11.8438 11.5745 11.8244 11.5553 11.8059C11.0969 11.3475 10.4616 11.1603 10.0916 11.0872C10.1653 11.4581 10.3525 12.0925 10.8103 12.5509C11.4978 13.2384 12.5681 13.3153 12.5788 13.3159C12.6427 13.319 12.7028 13.3471 12.7463 13.3942C12.7897 13.4412 12.8129 13.5034 12.8109 13.5674C12.8089 13.6313 12.7818 13.6919 12.7355 13.7362C12.6892 13.7804 12.6275 13.8046 12.5635 13.8037V13.8028Z"
      fill="#00086D"
    />
    <path
      d="M12.5619 13.8026C12.4979 13.8034 12.4362 13.7791 12.39 13.7348C12.3438 13.6906 12.3169 13.63 12.3149 13.5661C12.3129 13.5021 12.3361 13.44 12.3795 13.393C12.4229 13.346 12.483 13.3179 12.5469 13.3148C12.5572 13.3148 13.6309 13.236 14.3144 12.5501C14.7775 12.0888 14.9634 11.4563 15.0356 11.0857C14.6653 11.1595 14.0309 11.3467 13.5703 11.8045C13.5539 11.8202 13.5384 11.8368 13.5238 11.8542C13.484 11.9053 13.4255 11.9385 13.3613 11.9465C13.297 11.9545 13.2322 11.9366 13.1811 11.8968C13.13 11.857 13.0968 11.7986 13.0888 11.7343C13.0808 11.6701 13.0987 11.6053 13.1384 11.5542C13.1656 11.5212 13.1946 11.4899 13.2253 11.4604C14.0447 10.6442 15.2566 10.557 15.3075 10.5542C15.3421 10.5519 15.3768 10.5571 15.4092 10.5693C15.4417 10.5815 15.4712 10.6004 15.4958 10.6249C15.5203 10.6494 15.5394 10.6788 15.5517 10.7112C15.564 10.7436 15.5693 10.7783 15.5672 10.8129C15.5638 10.8645 15.4794 12.0795 14.6609 12.8963C13.8425 13.7132 12.6297 13.7998 12.5784 13.8026H12.5619ZM2.78344 6.46854C2.71868 6.46854 2.65657 6.44283 2.61075 6.39707C2.56493 6.35131 2.53915 6.28923 2.53906 6.22447V4.7076C2.53917 4.66357 2.55115 4.62038 2.57375 4.5826L3.92563 2.31541C3.94204 2.28787 3.96372 2.26384 3.98942 2.24468C4.01513 2.22552 4.04435 2.21161 4.07543 2.20375C4.10651 2.19589 4.13883 2.19422 4.17055 2.19885C4.20228 2.20348 4.23278 2.21431 4.26031 2.23072C4.28785 2.24714 4.31188 2.26882 4.33104 2.29452C4.3502 2.32022 4.36411 2.34945 4.37197 2.38053C4.37984 2.41161 4.3815 2.44393 4.37687 2.47565C4.37225 2.50737 4.36142 2.53787 4.345 2.56541L3.0275 4.77479V6.22479C3.02742 6.28946 3.00167 6.35146 2.95591 6.39716C2.91014 6.44286 2.84811 6.46854 2.78344 6.46854ZM4.89063 6.46854C4.8259 6.46854 4.76382 6.44282 4.71805 6.39705C4.67228 6.35128 4.64656 6.2892 4.64656 6.22447V4.7076C4.64658 4.68014 4.65123 4.65288 4.66031 4.62697L5.45344 2.35979C5.46356 2.32896 5.47974 2.30046 5.50101 2.27596C5.52228 2.25146 5.54822 2.23144 5.57732 2.21708C5.60642 2.20273 5.63809 2.19432 5.67048 2.19235C5.70287 2.19037 5.73532 2.19488 5.76595 2.2056C5.79658 2.21632 5.82476 2.23304 5.84884 2.25478C5.87293 2.27653 5.89244 2.30285 5.90623 2.33222C5.92002 2.36159 5.92782 2.39342 5.92916 2.42584C5.93051 2.45826 5.92537 2.49062 5.91406 2.52104L5.13469 4.74979V6.22479C5.1346 6.28946 5.10885 6.35146 5.06309 6.39716C5.01733 6.44286 4.9553 6.46854 4.89063 6.46854ZM6.99938 6.46854C6.93462 6.46854 6.87251 6.44283 6.82669 6.39707C6.78087 6.35131 6.75508 6.28923 6.755 6.22447V4.7076C6.75505 4.69914 6.75558 4.69069 6.75656 4.68229L6.99063 2.41541C6.99726 2.35101 7.0292 2.29189 7.07942 2.25104C7.12965 2.21019 7.19404 2.19097 7.25844 2.1976C7.32283 2.20423 7.38196 2.23617 7.42281 2.28639C7.46366 2.33662 7.48288 2.40101 7.47625 2.46541L7.24344 4.7201V6.22479C7.24335 6.28946 7.2176 6.35146 7.17184 6.39716C7.12608 6.44286 7.06405 6.46854 6.99938 6.46854ZM9.10531 6.46854C9.04058 6.46854 8.97851 6.44282 8.93273 6.39705C8.88696 6.35128 8.86125 6.2892 8.86125 6.22447V4.72447L8.53875 2.47447C8.52968 2.41037 8.54644 2.34528 8.58535 2.29353C8.62427 2.24178 8.68214 2.20761 8.74625 2.19854C8.81036 2.18946 8.87545 2.20622 8.92719 2.24514C8.97894 2.28405 9.01311 2.34193 9.02219 2.40604L9.34688 4.67322C9.34864 4.6847 9.34948 4.6963 9.34938 4.70791V6.22479C9.34929 6.28946 9.32354 6.35146 9.27778 6.39716C9.23202 6.44286 9.16999 6.46854 9.10531 6.46854ZM11.2128 6.46854C11.1481 6.46862 11.0859 6.44299 11.04 6.39729C10.9942 6.35159 10.9683 6.28954 10.9681 6.22479V4.75354L10.1031 2.53479C10.0911 2.50486 10.0852 2.47286 10.0856 2.44063C10.0861 2.4084 10.0929 2.37658 10.1057 2.347C10.1185 2.31742 10.1371 2.29067 10.1603 2.2683C10.1835 2.24593 10.2109 2.22837 10.2409 2.21665C10.2709 2.20493 10.303 2.19927 10.3352 2.2C10.3675 2.20074 10.3992 2.20785 10.4287 2.22092C10.4581 2.234 10.4847 2.25278 10.5069 2.27619C10.5291 2.29959 10.5464 2.32715 10.5578 2.35729L11.4397 4.61947C11.4509 4.64772 11.4566 4.67784 11.4566 4.70822V6.22479C11.4565 6.28941 11.4308 6.35136 11.3851 6.39705C11.3394 6.44275 11.2774 6.46845 11.2128 6.46854Z"
      fill="#00086D"
    />
    <path
      d="M13.3217 6.46897H0.677656C0.612927 6.46897 0.550849 6.44325 0.505078 6.39748C0.459307 6.35171 0.433594 6.28963 0.433594 6.2249V4.70803C0.433827 4.65081 0.454182 4.5955 0.491094 4.55178L2.40203 2.28334C2.42507 2.2561 2.4538 2.23423 2.48619 2.21928C2.51858 2.20433 2.55385 2.19665 2.58953 2.19678H11.8789C11.9199 2.19675 11.9603 2.20707 11.9963 2.22679C12.0323 2.24651 12.0628 2.27499 12.0848 2.30959L13.5277 4.57678C13.5526 4.61601 13.5658 4.66154 13.5658 4.70803V6.22522C13.5657 6.28989 13.5399 6.35189 13.4942 6.39759C13.4484 6.4433 13.3864 6.46897 13.3217 6.46897ZM0.921719 5.98115H13.078V4.77897L11.7452 2.68522H2.70234L0.921094 4.7974L0.921719 5.98115ZM12.5636 9.10209C12.4989 9.10209 12.4368 9.07638 12.391 9.03061C12.3452 8.98484 12.3195 8.92276 12.3195 8.85803V7.05897C12.3218 6.99571 12.3485 6.93579 12.3941 6.89184C12.4396 6.84789 12.5005 6.82333 12.5638 6.82333C12.627 6.82333 12.6879 6.84789 12.7334 6.89184C12.779 6.93579 12.8057 6.99571 12.808 7.05897V8.85803C12.808 8.89011 12.8016 8.92187 12.7894 8.9515C12.7771 8.98113 12.7591 9.00805 12.7364 9.03072C12.7137 9.05338 12.6867 9.07136 12.6571 9.0836C12.6274 9.09585 12.5957 9.10213 12.5636 9.10209ZM9.70453 13.0443H1.43641C1.37168 13.0443 1.3096 13.0186 1.26383 12.9728C1.21806 12.927 1.19234 12.8649 1.19234 12.8002V7.13772C1.19234 7.07299 1.21806 7.01091 1.26383 6.96514C1.3096 6.91937 1.37168 6.89365 1.43641 6.89365C1.50114 6.89365 1.56321 6.91937 1.60898 6.96514C1.65476 7.01091 1.68047 7.07299 1.68047 7.13772V12.5562H9.70453C9.76926 12.5562 9.83134 12.5819 9.87711 12.6276C9.92288 12.6734 9.94859 12.7355 9.94859 12.8002C9.94859 12.8649 9.92288 12.927 9.87711 12.9728C9.83134 13.0186 9.76926 13.0443 9.70453 13.0443Z"
      fill="#00086D"
    />
    <path
      d="M6.70812 13.0439C6.6434 13.0439 6.58132 13.0182 6.53555 12.9725C6.48978 12.9267 6.46406 12.8646 6.46406 12.7999V8.49988H3.60531V12.7999C3.60531 12.8646 3.5796 12.9267 3.53383 12.9725C3.48806 13.0182 3.42598 13.0439 3.36125 13.0439C3.29652 13.0439 3.23444 13.0182 3.18867 12.9725C3.1429 12.9267 3.11719 12.8646 3.11719 12.7999V8.25676C3.11719 8.19203 3.1429 8.12995 3.18867 8.08418C3.23444 8.03841 3.29652 8.0127 3.36125 8.0127H6.70812C6.77285 8.0127 6.83493 8.03841 6.8807 8.08418C6.92647 8.12995 6.95219 8.19203 6.95219 8.25676V12.7999C6.95219 12.8646 6.92647 12.9267 6.8807 12.9725C6.83493 13.0182 6.77285 13.0439 6.70812 13.0439Z"
      fill="#00086D"
    />
    <path
      d="M5.73187 10.987C5.66715 10.987 5.60507 10.9613 5.5593 10.9155C5.51353 10.8697 5.48781 10.8077 5.48781 10.7429V10.3126C5.48781 10.2479 5.51353 10.1858 5.5593 10.14C5.60507 10.0943 5.66715 10.0686 5.73187 10.0686C5.7966 10.0686 5.85868 10.0943 5.90445 10.14C5.95022 10.1858 5.97594 10.2479 5.97594 10.3126V10.7417C5.9761 10.7738 5.96991 10.8057 5.95772 10.8355C5.94553 10.8652 5.92758 10.8923 5.9049 10.9151C5.88222 10.9379 5.85526 10.956 5.82556 10.9683C5.79587 10.9806 5.76403 10.987 5.73187 10.987ZM13.3172 4.95199H0.681563C0.616833 4.95199 0.554755 4.92628 0.508984 4.88051C0.463214 4.83474 0.4375 4.77266 0.4375 4.70793C0.4375 4.6432 0.463214 4.58112 0.508984 4.53535C0.554755 4.48958 0.616833 4.46387 0.681563 4.46387H13.3172C13.3819 4.46387 13.444 4.48958 13.4898 4.53535C13.5355 4.58112 13.5612 4.6432 13.5612 4.70793C13.5612 4.77266 13.5355 4.83474 13.4898 4.88051C13.444 4.92628 13.3819 4.95199 13.3172 4.95199Z"
      fill="#00086D"
    />
  </svg>
);
const ModalClosePeriod = ({ close, data, locations }: any) => {
  // debugger;
  console.log(data);

  const [checkedAll, setCheckedAll] = useState(false);
  const x: any = [];
  const valuesLocations = data?.locations
    ? data?.locations.map((e: any) => x.push(e.id))
    : [];
  console.log(valuesLocations);

  const [checkedBranches, setCheckedBranches] = useState(x || []);
  const { RangePicker } = DatePicker;
  const {
    mutate: ClosedPeriods,
    isLoading,
    error: addSalonError,
  } = useMutation(addClosedPeriods, {
    onSuccess: (res: any) => {
      if (res?.response?.status === 422 || res?.response?.status === 500) {
        message.error(res?.response?.data?.message);
      } else {
        message.success("ClosedPeriod added successfully");
        queryClient.invalidateQueries([queryKeys.listClosedPeriods]);
        close();
      }
    },
  });
  const { mutate: UpdateClosedPeriods, isLoading: isLoadingUpdate } =
    useMutation(updateClosedPeriods, {
      onSuccess: (res: any) => {
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          message.success("ClosedPeriod updated successfully");
          queryClient.invalidateQueries([queryKeys.listClosedPeriods]);
          close();
        }
      },
    });
  const { mutate: DeleteClosedPeriods, isLoading: isLoadingDelete } =
    useMutation(deleteClosedPeriod, {
      onSuccess: (res: any) => {
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          message.success("Closed Period Deleted");
          queryClient.invalidateQueries([queryKeys.listClosedPeriods]);
          close();
        }
      },
    });
  console.log(data);

  const onFinish = (values: any) => {
    data
      ? UpdateClosedPeriods({
          ...values,
          start_date: dayjs(values?.periodRange?.[0]).format("YYYY-MM-DD"),
          end_date: dayjs(values?.periodRange?.[1]).format("YYYY-MM-DD"),
          location_id: checkedBranches,
          id: data?.id,
        })
      : ClosedPeriods({
          ...values,
          start_date: dayjs(values.periodRange?.[0]).format("YYYY-MM-DD"),
          end_date: dayjs(values.periodRange?.[1]).format("YYYY-MM-DD"),
          location_id: checkedBranches,
        });
  };
  const options = locations?.data?.map((location: any) => ({
    label: (
      <div className="flex items-center gap-2 px-6 py-4 bg-white rounded-lg">
        {svg}
        <span>{location.name}</span>
      </div>
    ),
    value: location.id, // Ensure this is correctly mapped
  }));
  const onChange = (checkedValues: any) => {
    console.log("Checked Branches:", checkedValues);
    setCheckedBranches(checkedValues);
    setCheckedAll(checkedValues.length === options.length);
  };

  const onCheckAllChange = (e: any) => {
    const allChecked = e.target.checked;
    const newCheckedBranches = allChecked
      ? options.map((option: any) => option.value)
      : [];
    setCheckedBranches(newCheckedBranches);
    setCheckedAll(allChecked);
  };
  const intl = useIntl();
  console.log(checkedBranches);
  console.log(data, "checkedBranchescheckedBranches");
  return (
    <div className="flex flex-col items-center justify-center w-full px-16 pt-12 pb-6 max-md:pt-1 max-md:px-1 max-md:pb-3">
      <h4 className="mb-4 text-lg font-semibold text-color-primary">
        {data ? (
          intl.formatMessage({ id: "editClosedPeriodHeader" })
        ) : (
          <FormattedMessage
            id="addNewClosedPeriodTitle"
            defaultMessage="Add a New Closed Period"
          />
        )}
      </h4>
      {data ? null : (
        <p className="mb-8 text-[#75757E] text-sm">
          <FormattedMessage
            id="completeFollowingInformationToAddClosedPeriod"
            defaultMessage="Complete the following information to add a closed period"
          />
        </p>
      )}
      <Form
        className="w-full rounded-lg"
        onFinish={onFinish}
        layout={"vertical"}
        dir="rtl"
        initialValues={{
          periodRange: data
            ? [dayjs(data?.start_date), dayjs(data?.end_date)]
            : "",
          description: data?.description || "",
        }}
      >
        <div className="grid items-center gap-4">
          <Form.Item
            name="periodRange"
            label={
              <FormattedMessage
                id="periodRangeLabel"
                defaultMessage="Add Period"
              />
            }
            className="w-full"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="periodRangeRequiredErrorMessage"
                    defaultMessage="Enter the period"
                  />
                ),
              },
            ]}
            required={false}
          >
            <RangePicker
              className="custom-range-picker !w-full"
              onChange={(e: any) => console.log(e)}
              placement="topLeft"
              placeholder={[
                intl.formatMessage({ id: "startDatePlaceholder" }),
                intl.formatMessage({ id: "endDatePlaceholder" }),
              ]}
            />
          </Form.Item>
          <Form.Item
            name="description"
            label={
              <div>
                <FormattedMessage
                  id="descriptionLabel"
                  defaultMessage="Description"
                />
                <span className="text-[10px] font-semibold mx-1 text-[#75757E]">
                  (
                  <FormattedMessage
                    id="optionalLabel"
                    defaultMessage="Optional"
                  />
                  )
                </span>
              </div>
            }
            className="w-full"
          >
            <Input.TextArea
              placeholder={intl.formatMessage({ id: "descriptionPlaceholder" })}
            />
          </Form.Item>
          <Form.Item
            label={
              <div className="font-semibold text-color-primary">
                <FormattedMessage
                  id="selectBranchesLabel"
                  defaultMessage="Select Branches"
                />
              </div>
            }
            rules={[
              {
                required: checkedBranches.length <= 0,
                message: intl.formatMessage({ id: "selectSalonErrorMessage" }),
              },
            ]}
            required={false}
            name=""
            className="bg-[#FBFBFF] py-4 px-3"
          >
            <Checkbox
              indeterminate={
                checkedBranches.length > 0 &&
                checkedBranches.length < options.length
              }
              onChange={onCheckAllChange}
              checked={checkedAll}
            >
              <FormattedMessage
                id="selectAllLabel"
                defaultMessage="Select All"
              />
            </Checkbox>
            <Checkbox.Group
              options={options}
              className="grid items-center w-full gap-4 mt-6 col-2"
              value={checkedBranches}
              onChange={onChange}
            />
          </Form.Item>
          {/* {data && (
            <div
              onClick={() => DeleteClosedPeriods(data.id)}
              className={`${
                isLoadingDelete && "opacity-50"
              } flex items-center gap-2 mb-6 -mt-6 text-[#C43535] w-full justify-center cursor-pointer`}
            >
              <span>{intl.formatMessage({ id: "delete_period" })}</span>
              {deleteSVG}
            </div>
          )} */}
        </div>
        <div className="flex items-center w-full gap-4">
          <Button
            type="primary"
            className="w-full h-full px-2 text-lg text-white rounded-md bg-color-primary"
            htmlType="submit"
            loading={data ? isLoadingUpdate : isLoading}
          >
            {data
              ? intl.formatMessage({ id: "updatePeriodButtonLabel" })
              : intl.formatMessage({ id: "addPeriodButtonLabel" })}
          </Button>
          <Button
            type="primary"
            onClick={() => close()}
            className="w-full h-full px-2 text-lg text-black rounded-md bg-color-light"
            htmlType="button"
          >
            {intl.formatMessage({ id: "cancel" })}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ModalClosePeriod;
